import { DROPDOWN_SELECT_UNPAID_PRACTICE } from "../../../enums/Request/request.types";

export const dropdownSelectionUnpaidPractice = ({ elem, stateNameUnpaid }) => {
    return {
        type: DROPDOWN_SELECT_UNPAID_PRACTICE,
        payload: { elem, stateNameUnpaid },
    };
};
